import React from 'react';
import {SlideBaseRenderer} from './slide-base.renderer';
import {LiveStreamHlsPocSlideComponent} from '../../../components/video-slides/components/live-stream-slide/live-stream-hls-poc-slide.component';

export class LiveStreamSlideRenderer extends SlideBaseRenderer {
    render(): React.ReactElement {
        return (<LiveStreamHlsPocSlideComponent key={this.uniqueKey} gameInfo={this.gameInfo} />);
    }
}
